/**
*
* Loader
*
*/

import React from 'react';

import SVG  from 'react-inlinesvg';

import Loading from 'assets/icons/loading_2.svg';

import LoaderWrapper from './styles/LoaderWrapper';
import LoaderIcon from './styles/LoaderIcon';

function Loader(props) {

  const {
    thisStyles,
    thisStylesIcon,
    notFullHeight
  } = props;

  return (
    <LoaderWrapper thisStyles={thisStyles}>
      <LoaderIcon  thisStylesIcon={thisStylesIcon} notFullHeight={notFullHeight}>
        <SVG
          src={Loading}
          cacheRequests={true}
        />
      </LoaderIcon>
    </LoaderWrapper>
  );
}

export default Loader;
